import { FC } from 'react';
import { IFilterProps } from '.';
import { Button } from 'src/Components';
import { TableColumnEnumType } from 'src/Components/DataGrid';
import Select from './Select';
import st from "./DefFilterCommon.module.scss";

/** Компонента-обертка Enum или Boolean фильтра для подготовки данных для выпадающего списка */
const Enum: FC<IFilterProps> = ( props ) => {

	const { columnId, isShowModal, columnType,
		value, setValue,
		cancelHandler, applyValueHandler 
	} = props;
	
	/** Подготовка массива опций */
	const getOptions = (): Array<TableColumnEnumType> => {
		if ( columnType.type?.includes( "bool" ) )
			return BooleanEnums;
		else if ( !!columnType.enums ) {
			if ( !columnType.enums.length ) 
				return [];
			else
				return columnType.enums.map( e => {
					if ( typeof e === "string" ) {
						return {
							id: e,
							title: e
						};
					}
					else {
						return {
							id: e.id,
							title: getTitle(e)
						};
					}
				});
		}
		else {
			throw new Error( `Для колонки ${columnId} с типом ${columnType.type}, не определены опции ( enums )!` );
		}
	};

	/** Подготовка списка выбранных значений */
	const prepareValue = () => {
		if ( !value ) return [];
		else if ( Array.isArray( value ) )
			return value;
		else
			return [ value ];
	};

	/** Рендер кнопок отмена/применить */
	const renderButtons = () => {
		if ( !value || !value.length ) return null;
		return (
			<div className={st.modalButtonsSB}>
				<Button id={'filter_cancel-' + columnId} onClick={cancelHandler} variant='red' outline>Отмена</Button>
				<Button id={'filter_apply-' + columnId} onClick={applyValueHandler}>Применить</Button>
			</div>
		);
	};

	return (
		<Select
			isShowModal={isShowModal}
			multiple={!!columnType.multiple}
			options={getOptions()}
			selectedIds={prepareValue()}
			setSelected={setValue}
			renderButtons={renderButtons}
		/>
	);
};

/** Возвращает текст опции */
const getTitle = ( option: TableColumnEnumType ): string => option.title ?? option.id;

/** Массив опций для булевых колонок */
const BooleanEnums = [
	{
		id: "",
		title: "Все"
	},
	{
		id: "true",
		title: "Да"
	},
	{
		id: "false",
		title: "Нет"
	}
];

export default Enum;
